package ru.villawonka.app

actual object BuildConfig {
    actual val isDebug: Boolean = js("process.env.NODE_ENV === 'development'") as Boolean
    actual val isRelease: Boolean = js("process.env.NODE_ENV === 'production'") as Boolean
    actual val buildType: String = js("process.env.NODE_ENV") as String
}